module.exports = __webpack_public_path__ + "static/media/Yue Li.bef50c9d.png";